/**
 * 유사 문제 생성 중 영역의 워시 — ai-builder-chat 의 AiBuilderGenerationLockOverlay 워시와 같은 기법.
 * white ↔ gray-200 좌→우(90deg) 반복 그라디언트의 background-position 을 정확히 한 주기만큼 가로로 선형 이동시켜
 * 이음새 없이 오른쪽으로 계속 흐르는 것처럼 보인다.
 * 주기는 이 영역(약 600×180)에 맞춰 잡았다 — 화면 전체용(1800)을 그대로 쓰면 영역 안에서 색이 거의 안 변한다.
 * 부모는 `relative overflow-hidden` 이어야 한다.
 */
import { Gray200 } from '@zep-us/zus/tokens';
import { motion, useReducedMotion } from 'framer-motion';
const WASH_DURATION_S = 5;

// 밴드 한 주기의 길이. 타일 폭 = 한 주기라 x 를 period 만큼 옮기면 위상이 정확히 한 바퀴 돈다.
const WASH_PERIOD_PX = 720;

// 회색 밴드가 주기에서 차지하는 폭의 비율 — 나머지는 흰색 골짜기.
const WASH_BAND_RATIO = 0.5;
const WASH_BAND_START_PX = WASH_PERIOD_PX * (1 - WASH_BAND_RATIO) / 2;
const WASH_BAND_END_PX = WASH_PERIOD_PX * (1 + WASH_BAND_RATIO) / 2;

// 색은 Figma 생성 중 영역 그대로: white → gray-200(color/gray/200).
const WASH_VALLEY = '#FFFFFF';
const WASH_BACKGROUND = `repeating-linear-gradient(90deg, ${WASH_VALLEY} 0px, ${WASH_VALLEY} ${WASH_BAND_START_PX}px, ${Gray200} ${WASH_PERIOD_PX / 2}px, ${WASH_VALLEY} ${WASH_BAND_END_PX}px, ${WASH_VALLEY} ${WASH_PERIOD_PX}px)`;
export const SimilarQuestionWash = () => {
  const shouldReduceMotion = useReducedMotion();
  return <motion.div aria-hidden data-similar-question-wash className="pointer-events-none absolute inset-0" style={{
    backgroundImage: WASH_BACKGROUND,
    backgroundSize: `${WASH_PERIOD_PX}px 100%`
  }} animate={shouldReduceMotion ? undefined : {
    backgroundPosition: ['0px 0px', `${WASH_PERIOD_PX}px 0px`]
  }} transition={{
    duration: WASH_DURATION_S,
    ease: 'linear',
    repeat: Infinity
  }} data-sentry-element="unknown" data-sentry-component="SimilarQuestionWash" data-sentry-source-file="SimilarQuestionWash.tsx" />;
};